import { formatDate } from '@angular/common';
import { Component, ViewChild, ElementRef } from '@angular/core'
import { InputBaseComponent } from '../input-base.component';
import { BsDatepickerDirective } from 'ngx-bootstrap/datepicker';
declare var $: any;

@Component({
    selector: 'ct-input-date',
    templateUrl: './ct-input-date.component.html',
    styleUrls: ['./ct-input-date.component.css']
})


export class CtInputDateComponent extends InputBaseComponent {
    @ViewChild('el') formControl: ElementRef;
    @ViewChild('dp') datePicker: BsDatepickerDirective;
    private dateType: string;
    private format: string;
    private minDate: string;
    private maxDate: string;
    private dbFormat: string;
    currentData: Date;

    public textOrientation: string = "left"
    constructor() {
        super();
    }

    ngAfterViewInit() {
        this.setInitValue(this.getValue());
        this.getMetaData().controlProperties.dbFormat = !this.getMetaData().controlProperties.dbFormat || this.getMetaData().controlProperties.dbFormat === '' ? 'yyyy/mm/dd' : this.getMetaData().controlProperties.dbFormat;
        this.setProperties(this);
        if (this.getMetaData().controlProperties.value && this.getMetaData().controlProperties.value === "sysdate") {
            this.setValue(formatDate(new Date(), 'DD/MM/YYYY', 'es-CR'))
            this.setInitValue(this.utilService.parseDbDateToUiDate(this.getValue()));
        } else
            this.setInitValue(this.utilService.parseDbDateToUiDate(this.getValue()));

        this.setPlaceHolder(this.getMetaData().controlProperties.format);
    }

    //Methods
    public getValue() {
        if (this.currentData != undefined) {
            if ((this.currentData.toString()).includes('/')) {
                let newDate = (this.currentData.toString() === '') ? '' : this.currentData.toString().split('/');
                return newDate[2] + newDate[1] + newDate[0];

            }
            else {
                const dateFormat =
                    this.currentData.getFullYear() +
                    ('0' + (this.currentData.getMonth() + 1)).slice(-2) +
                    ('0' + this.currentData.getDate()).slice(-2);
                return dateFormat.toString();
            }
        }
    }

    public setValue(value: any): void {
        if (value?.length < 10) return
        if (value)
            if (value === 'sysdate')
                super.setValue(formatDate(new Date(), 'DD/MM/YYYY', 'es-CR'));
            else if ((value.toString()).includes('/'))
                super.setValue(value);
            else if ((value.toString()).includes('GMT')) {
                const dateFormat =
                    ('0' + value.getDate()).slice(-2) + '/' +
                    ('0' + (value.getMonth() + 1)).slice(-2) + '/' +
                    value.getFullYear();
                super.setValue(dateFormat);
            }
            else {
                let date = value.substr(-8, 2) + '/' + value.substr(-10, 2) + '/' + value.substr(0, 4);
                super.setValue(date);
            }

        else
            super.setValue(value);
    }

    public setReadOnly(readOnly: boolean): void {
        super.setReadOnly(readOnly);
        this.formControl.nativeElement.readOnly = readOnly;
    }

    public togglePicker() {
        if(this.getReadOnly()) this.datePicker.hide();
        else this.datePicker.show();
    }

    //Properties
    getDateType(): string { return this.dateType }
    getFormat(): string { return this.format }
    getMinDate(): string { return this.minDate }
    getMaxDate(): string { return this.maxDate }
    getFormControl(): any { return this.formControl }
    getDbFormat(): string { return this.dbFormat }
    getUiValue() { return super.getValue() }
    getInitValue(): any {
        return super.getInitValue();
    }

    setDateType(dateType: string): void { this.dateType = dateType }
    setFormat(format: string): void { this.format = format }
    setMinDate(minDate: string): void { this.minDate = minDate }
    setMaxDate(maxDate: string): void { this.maxDate = maxDate }
    setDbFormat(dbFormat: string): void { this.dbFormat = dbFormat }
    getTextOrientation():string { return this.textOrientation };
  
    setTextOrientation(textOrientation: string): void { this.textOrientation = textOrientation }
}

